import { SUBSCRIPTION_FEE, } from "@frameworks/web/redux/interfaces/Reports/iSubscriptionFee";
import { combineReducers } from "redux";
import commonOnePlatFormReducer from "@frameworks/web/redux/reducers/common/commonReducer";
const initState = {
    subscriptionFee: {
        rateBased: [],
        volBased: [],
    },
};
const SubscriptionFeeReducer = (state = initState, action) => {
    switch (action.type) {
        case SUBSCRIPTION_FEE:
            return Object.assign(Object.assign({}, state), { subscriptionFee: action.payload.subscriptionFee });
        default:
            return Object.assign({}, state);
    }
};
let SubscriptionFeeReducerE = combineReducers({
    reducersData: SubscriptionFeeReducer,
    commonData: commonOnePlatFormReducer,
});
export default SubscriptionFeeReducerE;
